import { render, staticRenderFns } from "./AccordionTable.vue?vue&type=template&id=67e7c00e"
import script from "./AccordionTable.vue?vue&type=script&lang=js"
export * from "./AccordionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports